export const LogoutActionSelector = 'logoutAction';
